import Household from "./Household"
import { Child } from "./Child"
import { Client } from "./Client"
import { Employer } from "./Employer"

export const cardTypes = {
  Child,
  Client,
  Household,
  Employer
}
